import { useEffect, useRef, useState } from 'react';
import styles from './CSVTextAreaEditor.module.css';
import Button from '../common/Button';
export interface CSVTextAreaEditorProps {
  mapData: string[][];
  onComplete: (text: string) => void;
  onCancle:() => void;
}

export default function CSVTextAreaEditor({ mapData, onComplete, onCancle }: CSVTextAreaEditorProps) {
  const [text, setText] = useState<string>(mapData.map(row => row.join(',')).join('\n'));
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {    
    //textarea로 스크롤 이동
    textAreaRef.current!.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
  };

  const handleComplete = () => {
      onComplete(text);
  };
  
  const handleCancle = () => {
      onCancle();
  };

  return (
    <div className={styles.editorWrapper}>
        <textarea
            className={styles.textArea}
            ref={textAreaRef}
            value={text}
            onChange={handleChange}
        />
        <div className={styles.buttonRow}>
            <Button label={"완료"} size={"medium"} background={"var(--main-color)"} onClick={() => {handleComplete()}} />
            <Button label={"취소"} size={"medium"} background={"var(--main-color)"} onClick={() => {handleCancle()}} />
        </div>
    </div>
    
  );
}
